export default {
	pages: {
		home: '야외 장비 스토어에 오신 것을 환영합니다!',
		products: '제품',
		interactive: '인터랙티브 기어 탐색기',
		environmental: '환경에 대한 우리의 약속',
		cart: '장바구니',
		login: '로그인',
	},
	interactive_gear_explorer: {
		title: '인터랙티브 기어 탐색기',
		steps: {
			0: '어떤 활동을 계획하고 있나요?',
			1: '예산이 어떻게 되나요?',
			2: '이것들은 권장 제품입니다!',
		},
		buttons: {
			hiking: '등산',
			climbing: '등반',
			camping: '캠핑',
		},
	},
	header: {
		home: '홈',
		admin: '관리자',
		interactive: '인터랙티브 기어 탐색기',
		environmental: '환경 약속',
		products: '제품',
		cart: '장바구니',
		login: '로그인',
		logout: '로그아웃',
	},
	product_card: {
		add_to_cart: '장바구니에 추가',
		goto_product: '제품으로 이동',
	},
	environment: {
		title: '우리의 환경 약속',
		sustainable_materials: {
			title: '지속 가능한 소재',
			description: '우리는 모든 소재가 엄격한 지속 가능성 기준을 준수하는 공급 업체에서 공급되도록 합니다.',
		},
		energy_efficiency: {
			title: '에너지 효율성',
			description:
				'저희 제조 공정은 최소한의 에너지 소비를 위해 최적화되어 있으며, 탄소 발자국을 줄이기 위해 노력합니다.',
		},
		waste_reduction: {
			title: '폐기물 감축',
			description: '재활용 계획 및 더 긴 수명을 가진 제품을 디자인함으로써 폐기물을 적극적으로 감축합니다.',
		},
		green_packaging: {
			title: '친환경 포장',
			description: '친환경 포장 솔루션으로 전환하여 비분해성 소재 사용을 최소화하려고 합니다.',
		},
		ecological_conservation: {
			title: '생태 보전',
			description:
				'다양한 생태 보전 프로그램을 지원함으로써 우리의 생존에 중요한 자연 환경을 보호하기 위해 노력합니다.',
		},
		education_and_collaboration: {
			title: '교육 및 협력',
			description:
				'교육 프로그램과 협력을 통해 환경 인식을 높이고 야외 산업 내에서 더욱 친환경적인 실천을 촉진하고 있습니다.',
		},
	},
	products: {
		title: '우리의 제품',
		categories: {
			all: '모두',
			sleeping_bags: '침낭',
			tents: '텐트',
			camping_chairs: '캠핑 의자',
			camping_tables: '캠핑 테이블',
			portable_lights: '휴대용 조명',
			stoves: '난로',
			coolers: '쿨러',
			tools: '도구',
			backpacks: '배낭',
			other: '기타',
			kits: '키트',
			footwear: '신발',
			undefined: '알 수 없음',
		},
	},
	login: {
		title: '로그인',
		emailPlaceholder: '이메일',
		passwordPlaceholder: '비밀번호',
		submit: '로그인',
		signup: '저희 스토어 처음이세요?',
		signupDescription: '독점 혜택을 즐기려면 지금 가입하세요!',
		signupBenefit: '제품에 대한 최신 뉴스 및 업데이트 받기',
		signupBenefit2: '특별 제공 및 할인 받기',
	},
	footer: {
		title: '야외 장비 스토어',
		menu: {
			title: '메뉴',
			home: '홈',
			products: '제품',
			interactive: '인터랙티브 기어 탐색기',
			environmental: '환경 약속',
			cart: '장바구니',
			login: '로그인',
		},
		information: {
			title: '정보',
			about: '회사 소개',
			contact: '문의하기',
			privacy: '개인 정보 보호 정책',
			terms: '이용 약관',
			careers: '채용',
		},
	},
	home: {
		title: '아웃도어를 위해 준비하다',
		products: '우리의 제품 탐색',
		environmental: '우리의 환경적 약속',
		interactive: '우리의 상호 작용형 기어 탐색기를 시도해보세요',
	},
	product: {
		title: '제품 세부 정보',
		carbon_footprint: '탄소 발자국',
		recyclable_materials: '재활용 가능한 재료',
		end_of_life_options: '생명 종료 옵션',
		add_to_cart: '장바구니에 추가',
	},
};
